import axios from 'axios'
import { Loading } from 'element-ui'
import store from '../store'

let needLoadingRequestCount = 0

function showFullScreenLoading () {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) {
    return false
  }
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

let loading

function startLoading () {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.2)'
  })
}

function endLoading () {
  loading.close()
}

// 请求超时 请求头
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers.post['accountRole'] = 'VIP'
axios.defaults.headers.get['accountRole'] = 'VIP'
axios.defaults.headers.post['org'] = '21188075522202009676dfd1c0522d42'
axios.defaults.headers.get['org'] = '21188075522202009676dfd1c0522d42'

// 请求拦截器
axios.interceptors.request.use(config => {
  if (config.showLoading) {
    showFullScreenLoading()
  }
  let currentUserInfo = store.state.currentUserInfo
  let token = currentUserInfo.token
  token && (config.headers.vipToken = token)
  return config
}, err => {
  throw err
})

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.config.showLoading) {
      tryHideFullScreenLoading()
    }
    if (response.data && response.data.code < 400 && response.data.code >= 200) {
      return response.data.data
    } else {
      throw new Error(response.data.msg || response.data.message)
    }
  }, err => {
    tryHideFullScreenLoading()
    throw err
  }
)

const ajax = {
  /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  get: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      axios.get(url, {
        params: params,
        ...showLoadingOptions
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /**
   * delete，对应delete请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  del: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      axios.delete(url, {
        params: params,
        showLoading: true,
        ...showLoadingOptions
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  post: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      axios.post(url, params, showLoadingOptions)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * 封装patch请求
   * @param url
   * @param params
   * @returns {Promise}
   */
  patch: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      axios.patch(url, params, showLoadingOptions)
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
    })
  },

  /**
   * put 请求
   * @param  url
   * @param  params
   */
  put: (url, params, showLoadingOptions = { showLoading: true }) => {
    return new Promise((resolve, reject) => {
      axios.put(url, params, showLoadingOptions)
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
    })
  }
}

export default ajax
